import { render } from "./HZLink.vue?vue&type=template&id=a4b69cac"
import script from "./HZLink.vue?vue&type=script&lang=js"
export * from "./HZLink.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Develop\\web\\notigo_base\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__